
import { defineComponent, ref, onBeforeUnmount } from 'vue';
import LoaderSpm from '@/assets/lottie/Animation.json';
// eslint-disable-next-line import/extensions
import '@/assets/js/lottie-player.js';

export default defineComponent({
  name: 'TheSpinner',

  setup() {
    const spinnerLottieRef = ref();

    onBeforeUnmount(() => {
      if (spinnerLottieRef.value) {
        spinnerLottieRef.value.destroy();
      }
    });

    return {
      LoaderSpm,
      spinnerLottieRef,
    };
  },
});
